import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicCommercialFilled({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M13.27 13.4l.44 1.2.02.09a.75.75 0 01-1.44.4l-.62-1.7h1.6zm-8.94 0l-.62 1.7a.75.75 0 01-1.44-.41l.02-.1.44-1.2h1.6zM12.5 3.25c1.24 0 2.25 1 2.25 2.25v5c0 1.24-1 2.25-2.25 2.25h-9c-1.24 0-2.25-1-2.25-2.25v-5c0-1.24 1-2.25 2.25-2.25zm0 1.5h-9a.75.75 0 00-.75.75v5c0 .41.34.75.75.75h9c.41 0 .75-.34.75-.75v-5a.75.75 0 00-.75-.75zm-.5.75c.28 0 .5.22.5.5v4a.5.5 0 01-.5.5H4a.5.5 0 01-.5-.5V6c0-.28.22-.5.5-.5h8zM8.06.52h.09l.01.01.08.02h.01l.03.02.06.03-.09-.04a.75.75 0 01.46.45L8.69.97 8.7 1v.01l.6 1.59H6.7L7.3 1V.97v.04a.76.76 0 01.45-.45l-.1.04a.75.75 0 01.07-.03l.03-.01a.77.77 0 01.2-.04h.1z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicCommercialFilled.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicCommercialFilled.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgBasicCommercialFilled svgRef={ref} {...props} />
));
export default ForwardRef;
